<template>
  <div class="col-12">
    <div class="row position-relative">
      <!-- {{broadcastParam}}
      <hr />
      {{broadcastParamSt}}-->
      <div class="col-12">
        <div class="bc-action-buttons">
          <button
            @click="cancelForm()"
            class="btn btn-md btn-outline-secondary btn-rounded bc-action-btn"
            type="button"
            :disabled="isSavingContent"
          >
            Batal
          </button>
          <button
            @click="handleSaveClick"
            class="btn btn-md btn-success btn-rounded bc-action-btn"
            type="button"
            :disabled="isSavingContent"
            :aria-busy="isSavingContent ? 'true' : 'false'"
          >
            <i
              class="fa"
              :class="isSavingContent ? 'fa-spinner fa-spin' : 'fa-check'"
            ></i>
            {{ isSavingContent ? "Menyimpan..." : "Simpan Perubahan" }}
          </button>
        </div>
      </div>
      <div class="col-12 mb-3">
        <div class="ab-testing-toggle">
          <span class="ab-testing-icon"><i class="fa fa-flask"></i></span>
          <div class="ab-testing-content">
            <div class="d-flex align-items-center justify-content-between flex-wrap">
              <div>
                <h6 class="mb-1 font-weight-bold">Variasi Pesan</h6>
                <p class="text-muted small mb-0">
                  Buat beberapa variasi pesan untuk digunakan dalam broadcast.
                  Maksimal 5 variasi.
                </p>
              </div>
              <label class="ab-switch mb-0">
                <input
                  type="checkbox"
                  :checked="broadcastParam.ab_testing_enabled"
                  @change="onAbTestingToggle"
                />
                <span class="ab-switch-slider"></span>
                <span class="sr-only">Aktifkan Variasi Pesan</span>
              </label>
            </div>
            <small
              v-if="!broadcastParam.ab_testing_enabled && (broadcastParam.variants || []).length"
              class="text-muted d-block mt-2"
            >
              Data varian tersimpan dan akan muncul kembali saat Variasi Pesan diaktifkan.
            </small>
          </div>
        </div>

        <div v-if="broadcastParam.ab_testing_enabled" class="mt-3">
          <div class="d-flex align-items-center justify-content-between flex-wrap mb-2">
            <div class="font-weight-bold">
              {{ activeVariants.length }} dari {{ maxVariants }} varian
            </div>
            <small class="text-muted">
              Setiap varian dapat memiliki teks, media, dan pesan interaktif sendiri.
            </small>
          </div>

          <div class="row ab-variant-grid">
            <div
              class="col-12 col-sm-6 col-lg-3 mb-2"
              v-for="(variant, index) in activeVariants"
              :key="variant.variant_code"
            >
              <div
                class="ab-variant-card"
                :class="{ active: activeVariantIndex === index }"
              >
                <button
                  type="button"
                  class="ab-variant-main"
                  @click="switchVariant(index)"
                >
                  <span
                    class="ab-variant-code"
                    :class="variantStatusClass(index)"
                  >
                    {{ variant.variant_code }}
                  </span>
                  <span class="ab-variant-info">
                    <span class="ab-variant-title">Content {{ variant.variant_code }}</span>
                    <span
                      class="ab-variant-status"
                      :class="variantStatusClass(index)"
                    >
                      <i class="fa" :class="variantStatusIcon(index)"></i>
                      {{ variantStatusLabel(index) }}
                    </span>
                  </span>
                </button>
                <button
                  v-if="index > 0"
                  type="button"
                  class="ab-variant-delete"
                  title="Hapus varian"
                  aria-label="Hapus varian"
                  @click.stop="confirmRemoveVariant(index)"
                >
                  <i class="fa fa-trash-o"></i>
                </button>
              </div>
            </div>

            <div class="col-12 col-sm-6 col-lg-3 mb-2" v-if="canAddVariant">
              <button type="button" class="ab-variant-add" @click="addVariant">
                <i class="fa fa-plus"></i>
                <span class="ab-variant-add-title">Tambah varian</span>
                <span class="ab-variant-add-sub">
                  {{ maxVariants - activeVariants.length }} slot tersisa
                </span>
              </button>
            </div>
            <div class="col-12 col-sm-6 col-lg-3 mb-2" v-else>
              <div class="ab-variant-add disabled">
                <i class="fa fa-plus"></i>
                <span class="ab-variant-add-title">Batas tercapai</span>
                <span class="ab-variant-add-sub">Maksimal {{ maxVariants }} varian</span>
              </div>
            </div>
          </div>

          <small
            v-if="!canAddVariant && activeVariants.length < maxVariants"
            class="text-muted d-block mt-1"
          >
            Simpan penghapusan varian terlebih dahulu untuk menambah varian baru.
          </small>
        </div>
      </div>
      <div class="col-12">
        <div class="row position-relative">
          <div class="col-lg-8 mb-3">
            <div class="ab-editor-card">
              <div class="ab-card-header">
                <div>
                  <h5 class="mb-1">
                    Konten {{ isAbTestingEnabled && activeVariant ? activeVariant.variant_code : "Pesan" }}
                  </h5>
                  <small class="text-muted">
                    {{ isAbTestingEnabled ? "Atur isi pesan, media, dan interaksi untuk varian ini." : "Atur isi pesan Broadcast." }}
                  </small>
                </div>
                <span v-if="isAbTestingEnabled && activeVariant" class="ab-status-pill"
                  :class="variantStatusClass(activeVariantIndex)">
                  <i class="fa" :class="variantStatusIcon(activeVariantIndex)"></i>
                  {{ variantStatusLabel(activeVariantIndex) }}
                </span>
              </div>
              <div class="ab-card-body">
                <div class="ab-section" v-if="isAbTestingEnabled && activeVariant">
                  <label class="ab-section-title">Jenis pesan</label>
                  <select v-model="broadcastParam.message.message_type" class="form-control"
                    style="max-width: 260px;"
                    @change="updateMessageTypeCurrent($event.target.value)">
                    <option value="text">Teks</option>
                    <option value="image">Gambar</option>
                    <option value="video">Video</option>
                    <option value="document">Dokumen</option>
                  </select>
                </div>

                <div class="ab-section">
                  <label class="ab-section-title" data-tour-step="2.1">Pesan</label>
                  <chat-component v-model="broadcastParam.message.text" :key="activeVariantKey" />
                      <!-- {{broadcastParam}} -->
                      <!-- <div class="message-bar">
                        <div class="message-inner">
                          <div class="message-area">
                            <div class="input-group">
                              <textarea
                                :style="'height:300px'"
                                ref="messagebox"
                                class="form-control"
                                v-model="broadcastParam.message.text"
                                :placeholder="'Type message...'"
                              ></textarea>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 px-0">
                        <div class="card border-0">
                          <div class="card-body">
                            <a-dropdown-button @click="emojiToggle()">
                              <img
                                style="width: 15px"
                                src="@/assets/emoji.png"
                                alt
                              />
                              <a-menu slot="overlay" >
                                <a-menu-item
                                  v-for="temp in templateMessage"
                                  :key="temp"
                                  @click="addTemplateToMesage(temp)"
                                >
                                  {{ temp }}
                                </a-menu-item>
                              </a-menu>
                            </a-dropdown-button>
                            <a-button-group>
                              <a-button
                                @click="applyStyle('*')"
                                style="font-weight: bold"
                                >B</a-button
                              >
                              <a-button
                                @click="applyStyle('_')"
                                style="font-style: italic"
                                >I</a-button
                              >
                              <a-button
                                @click="applyStyle('~')"
                                style="text-decoration: line-through"
                                >s</a-button
                              >
                              <a-button
                                @click="applyStyle('```')"
                                style="font-family: monospace"
                                >MONO</a-button
                              >
                            </a-button-group>
                            <Emoji
                              :open="emojiAttr.open"
                              :width="emojiAttr.width"
                              :height="emojiAttr.height"
                              style="z-index: 9999"
                              searchLabel="Search emoji here"
                              @click="selectedEmoji"
                            />
                          </div>
                        </div>
                      </div> -->
                </div>
                <div class="ab-section" v-if="broadcastParam.message.message_type != 'text'">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-12" v-if="broadcastParam.message.message_type != 'text'">
                    <label class="ab-section-title" for="">Attachment {{ broadcastParam.message.message_type == 'document' ? 'Dokumen' :
                      (broadcastParam.message.message_type == 'image') ? 'Gambar' : 'Video'
                    }}</label>
                    <div class="form-group">
                      <div v-show="files.length == 0 &&
                        broadcastParam.is_custom_url == false
                        " class="col-md-12 upload-drop-zone" id="drop-zone">
                        <center>
                          <i class="fa fa-cloud-upload fa-2x"></i>
                          <span class="upload-text">
                            <label :for="name">
                              Just drag and drop file here
                            </label>
                          </span>
                        </center>
                      </div>
                      <div>
                        <!-- <form id="js-upload-form"> -->
                        <div class="col-md-12" v-if="broadcastParam.is_custom_url == true">
                          <div class="row">
                            <div class="col-md-12">
                              <div class="form-group row">
                                <label class="col-form-label">URL File</label>
                                <input type="text" class="form-control" v-model="broadcastParam.message.file_url" />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-12" v-if="broadcastParam.is_custom_url == false">
                          <!-- {{files}} -->
                          <!-- <h4 v-if="files.length">Uploading</h4> -->
                          <ul class="upload-list" v-if="files.length">
                            <li v-for="file in files" :key="file.id" class="file-list">
                              <div class="upload-wrap">
                                <div class="file-name">
                                  <!-- <i class="fa fa-photo"></i> -->
                                  <img style="width: 30px" v-if="file.thumb" :src="file.thumb" />
                                  {{ file.name }}
                                </div>
                                <div class="file-size">
                                  {{ formatSizes(file.size) }}
                                </div>
                                <div class="file-close">
                                  <span class="text-danger" v-if="file.error">{{
                                    file.error
                                  }}</span>
                                  <span v-else-if="file.success">
                                    <i class="text-success fa fa-check-circle"></i>
                                  </span>
                                  <span v-else-if="file.active">active</span>
                                  <span v-else></span>
                                  <a href="#" @click.prevent="$refs.uploadbc.remove(file)" class="text-warning">
                                    <i class="fa fa-trash-o"></i>
                                  </a>
                                </div>
                              </div>
                              <div class="progress progress-xs progress-striped"
                                v-if="file.active || file.progress !== '0.00'">
                                <div class="progress-bar bg-success" role="progressbar"
                                  :style="{ width: file.progress + '%' }"></div>
                              </div>
                              <div class="upload-process" v-if="file.active || file.progress !== '0.00'">
                                {{ file.progress }}% done
                              </div>
                            </li>
                          </ul>
                        </div>
                        <!-- </form> -->
                        <div class="col-sm-12" v-show="$refs.uploadbc &&
                          $refs.uploadbc.active == false &&
                          broadcastParam.is_custom_url == false
                          ">
                          <div class="submit-section">
                            <div class="input-group mb-3">
                              <div class="input-group-prepend">
                                <button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown"
                                  aria-haspopup="true" aria-expanded="false" v-if="uploadMessageType == ''">
                                  Options
                                </button>
                                <button :style="'margin:5px;'" class="btn btn-primary dropdown-toggle" type="button"
                                  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" v-else>
                                  {{ uploadMessageType }}
                                </button>
                                <div class="dropdown-menu">
                                  <a @click.prevent="
                                    updateMessageTypeCurrent(opt)
                                    " class="dropdown-item" href="#" v-for="(
opt, index
                                    ) in messageTypeOptionsUpload" :key="index">
                                    <i class="text-success fa fa-check-circle" v-if="uploadMessageType == opt"></i>
                                    {{ opt }}
                                  </a>
                                </div>
                              </div>
                              <div class="input-group-append">

                                <file-upload-bc :add-index="true" :key="activeVariantKey" class="btn btn-primary" :data="objFilesMessageHandler"
                                  :post-action="uploadUrl" :multiple="false" :headers="headers" :drop="true"
                                  :drop-directory="true" v-model="files" @input-filter="inputFilter"
                                  @input-file="inputFile" ref="uploadbc" :maximum="maximumUpload"
                                  :accept="computedAccept" :extensions="computedExtensions">
                                  <i class="fa fa-plus"></i> Select
                                </file-upload-bc>
                              </div>
                              <!-- <div class="input-group-append">
                              <button
                                v-if="false"
                                @click.prevent="$refs.uploadbc.active = true"
                                class="btn btn-outline-secondary"
                                type="button"
                              >Upload File</button>
                              </div>-->
                            </div>
                          </div>
                          <div class="col-sm-12 col-md-12">
                            <div class="text-muted">
                              <ul style="
                                  overflow-x: scroll;
                                  overflow-y: hidden;
                                  white-space: nowrap;
                                ">
                                <li class="text-wrap">
                                  Support files: {{ extensions }}
                                </li>
                                <li>MaxSize: {{ formatSizes(size) }}</li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        <div class="row" v-if="$refs.uploadbc && $refs.uploadbc.active == true">
                          <div class="col-sm-2">
                            <Skeleton :height="'40px'" :count="1" />
                          </div>
                          <div class="col-sm-2">
                            <Skeleton :height="'40px'" :count="1" />
                          </div>
                          <div class="col-sm-6">
                            <Skeleton :height="'40px'" :count="1" />
                          </div>
                          <div class="col-sm-2">
                            <Skeleton :height="'40px'" :count="1" />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12"
                        v-if="broadcastParam.message.file_url && files.length === 0">
                        <div class="alert alert-info py-2">
                          File sudah tersimpan.
                          <a href="javascript:void(0)" class="text-danger ml-2"
                            @click.prevent="clearActiveFile">Hapus file</a>
                        </div>
                      </div>
                      <table class="table borderless">
                        <tr>
                          <th style="width: 30%" class="text-right">
                            Url File
                          </th>
                          <th class="text-left">
                            <div class="onoffswitch">
                              <input type="checkbox" name="onoffswitch" class="onoffswitch-checkbox"
                                v-model="broadcastParam.is_custom_url" id="switch_url_file" />
                              <label class="onoffswitch-label" for="switch_url_file">
                                <span class="onoffswitch-inner"></span>
                                <span class="onoffswitch-switch"></span>
                              </label>
                            </div>
                          </th>
                          <th class="text-center">
                            &nbsp;
                            <!-- <label>Select Message Type &amp; Upload File</label>
                            <button
                              class="btn btn-outline-secondary dropdown-toggle"
                              type="button"
                              data-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                              v-if="uploadMessageType==''"
                            >Options</button>
                            <button
                              :style="'margin:5px;'"
                              class="btn btn-outline-secondary dropdown-toggle"
                              type="button"
                              data-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                              v-else
                            >{{uploadMessageType}}</button>
                            <div class="dropdown-menu">
                              <a
                                @click.prevent="updateMessageTypeCurrent(opt)"
                                class="dropdown-item"
                                href="#"
                                v-for="(opt,index) in messageTypeOptionsUpload"
                                :key="index"
                              >
                                <i
                                  class="text-success fa fa-check-circle"
                                  v-if="uploadMessageType==opt"
                                ></i>
                                {{opt}}
                              </a>
                            </div>-->
                          </th>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              </div>
<div class="ab-section">
                  <div class="d-flex align-items-start justify-content-between flex-wrap">
                    <div class="pr-3">
                      <label class="ab-section-title mb-1" data-tour-step="2.2">Interactive Message</label>
                      <small class="text-muted d-block">
                        Tambahkan tombol interaktif untuk memudahkan respons dari penerima.
                      </small>
                    </div>
                    <div class="onoffswitch">
                          <input type="checkbox" name="onoffswitch" class="onoffswitch-checkbox"
                            v-model="broadcastParam.interactive_message_status"
                            id="switch_interactive_message_status" />
                          <label class="onoffswitch-label" for="switch_interactive_message_status">
                            <span class="onoffswitch-inner"></span>
                            <span class="onoffswitch-switch"></span>
                          </label>
                        </div>
                      </div>
                      <div class="col-md-12" v-if="broadcastParam.interactive_message_status == true">
                        <div class="col-md-12" v-show="false">
                          <div class="form-group">
                            <div class="form-group form-focus select-focus">
                              <select v-model="broadcastParam.interactive_message_type
                                " class="form-control" @change="resetDetailButton">
                                <option :value="''">-- Select --</option>
                                <option v-for="(
row, idxBtn
                                  ) in interactiveMessageTypeList" :key="idxBtn" :value="row.id">
                                  {{ row.label }}
                                </option>
                              </select>
                              <label class="focus-label">Button Type</label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div style="margin-top: 10px" class="col-sm-12"
                        v-if="broadcastParam.interactive_message_status == true">
                        <!-- {{ broadcastParam.buttons }} -->
                        <div class="col-12">
                          <text-reply v-model="broadcastParam" :isShowForm="false" />
                        </div>
                        <!-- <template>
                          <div
                            v-for="index in defaultDetailTextReply"
                            :key="index"
                            class="col-md-12"
                          >
                            <div class="form-group form-focus select-focus">
                              <select
                                v-model="broadcastParam.buttons[index - 1]"
                                class="form-control selectTextReply"
                              >
                                <option :value="''">-- Select --</option>
                                <template
                                  v-for="(row, idxBtn) in textReplyRows"
                                >
                                  <option
                                    :ref="'text_reply_' + row.id"
                                    :value="row"
                                  >
                                    {{ row.title }}
                                  </option>
                                </template>
</select>
<label class="focus-label">Text Reply {{ index }}</label>
</div>
</div>
</template> -->
                      </div>
                      <div class="col-md-12" v-if="broadcastParam.interactive_message_status == true">
                        <div class="row" v-show="false">
                          <label>Configure Footer Message</label>
                          <div class="onoffswitch">
                            <input type="checkbox" name="onoffswitch" class="onoffswitch-checkbox"
                              v-model="broadcastParam.footer_message_status" id="switch_footer_message" />
                            <label class="onoffswitch-label" for="switch_footer_message">
                              <span class="onoffswitch-inner"></span>
                              <span class="onoffswitch-switch"></span>
                            </label>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12" v-if="
                        broadcastParam.footer_message_status == true &&
                        broadcastParam.interactive_message_status == true
                      ">
                        <div class="form-group">
                          <label>Footer Message:</label>
                          <input maxlength="30" v-model="broadcastParam.footer_message"
                            placeholder="eq: Powered by Waajo.id" type="text" class="form-control" />
                        </div>
                      </div>
                </div>
                            </div>
            </div>
            <div class="ab-nav-actions d-flex justify-content-between mt-3"
              v-if="isAbTestingEnabled && activeVariants.length > 1">
              <button type="button" class="btn btn-outline-secondary"
                :disabled="activeVariantIndex <= 0"
                @click="switchVariant(activeVariantIndex - 1)">
                <i class="fa fa-arrow-left"></i>
                {{ activeVariantIndex > 0 ? "Content " + activeVariants[activeVariantIndex - 1].variant_code : "Sebelumnya" }}
              </button>
              <button type="button" class="btn btn-outline-secondary"
                :disabled="activeVariantIndex >= activeVariants.length - 1"
                @click="switchVariant(activeVariantIndex + 1)">
                {{ activeVariantIndex < activeVariants.length - 1 ? "Content " + activeVariants[activeVariantIndex + 1].variant_code : "Berikutnya" }}
                <i class="fa fa-arrow-right"></i>
              </button>
            </div>
          </div>
          <div class="col-lg-4 mb-3">
            <div class="ab-preview-card">
              <div class="ab-card-header">
                <div>
                  <h5 class="mb-1">
                    <i class="fa fa-whatsapp text-success"></i> Preview WhatsApp
                  </h5>
                  <small class="text-muted" data-tour-step="2.3">
                    Pratinjau {{ isAbTestingEnabled && activeVariant ? "Content " + activeVariant.variant_code : "pesan" }}
                  </small>
                </div>
              </div>
              <div class="ab-preview-body">
                <div id="preview" :style="'background: url(\'' + whatsappBackground + '\');'">
                  <preview-message v-model="broadcastParam" :textReplyRows="textReplyRows" :buttonsRows="buttonsRows"
                    :linkRows="linkRows" />
                </div>
              </div>
              <div class="ab-checklist" v-if="isAbTestingEnabled && activeVariant">
                <div class="ab-checklist-title">Kelengkapan varian</div>
                <div class="ab-check-item" :class="isVariantContentFilled ? 'is-ok' : 'is-pending'">
                  <i class="fa" :class="isVariantContentFilled ? 'fa-check-circle' : 'fa-circle-o'"></i>
                  <span>
                    {{ broadcastParam.message.message_type === "text" ? "Konten pesan" : "Media" }}
                    {{ isVariantContentFilled ? "terisi" : "belum terisi" }}
                  </span>
                </div>
                <div class="ab-check-item is-ok">
                  <i class="fa fa-check-circle"></i>
                  <span>Jenis pesan: {{ messageTypeLabel }}</span>
                </div>
                <div class="ab-check-item" v-if="broadcastParam.message.message_type != 'text'"
                  :class="broadcastParam.message.file_url ? 'is-ok' : 'is-pending'">
                  <i class="fa" :class="broadcastParam.message.file_url ? 'fa-check-circle' : 'fa-circle-o'"></i>
                  <span>Attachment {{ broadcastParam.message.file_url ? "tersedia" : "belum tersedia" }}</span>
                </div>
                <div class="ab-check-item" v-if="broadcastParam.interactive_message_status"
                  :class="isInteractiveValid ? 'is-ok' : 'is-pending'">
                  <i class="fa" :class="isInteractiveValid ? 'fa-check-circle' : 'fa-circle-o'"></i>
                  <span>Konfigurasi interactive message {{ isInteractiveValid ? "valid" : "belum lengkap" }}</span>
                </div>
                <div class="ab-check-item is-optional" v-else>
                  <i class="fa fa-circle-o"></i>
                  <span>Pesan interaktif opsional</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <v-tour name="tourGuide2" :steps="tourSteps" :callbacks="tourCallbacks"></v-tour>
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";

import { Skeleton } from "vue-loading-skeleton";

import { APICore, APICoreV2 } from "@/utils/servicesApi";
import {
  getXAuthAgent,
  getXAuthToken,
  getAgentSession,
  getAuthBasic,
} from "@/utils/auth";

import FileUpload from "vue-upload-component";
import Cropper from "cropperjs";
import ImageCompressor from "@xkeshi/image-compressor";
import { VueChatEmoji, emojis } from "vue-chat-emoji";
require("vue-chat-emoji/dist/vue-chat-emoji.min.css");

import { marketplaceIcon, formatSizes } from "@/utils/helper";
import PreviewMessage from "./preview";
import ChatComponent from './chatComponent.vue';
import TextReply from './textReply.vue';

export default {
  components: {
    Skeleton,
    FileUploadBc: FileUpload,
    Emoji: VueChatEmoji,
    Carousel,
    Slide,
    PreviewMessage,
    ChatComponent,
    TextReply,
  },
  props: {
    activeIndex: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      activeVariantIndex: 0,
      maxVariants: 5,
      defaultDetailTextReply: 10,
      textReplyRows: [],
      textReplyParams: {
        columnFilters: {
          id: "",
          title: "",
          is_publish: "publish",
        },
        page: 1,
        perPage: 500, // perPage
      },
      tourId: "broadcast.step2",
      tourCallbacks: {
        onSkip: this.tourComplete,
        onFinish: this.tourComplete,
      },
      tourSteps: [
        {
          target: '[data-tour-step="2.1"]', // We're using document.querySelector() under the hood
          content: `Teks pesan yang akan dikirim. Support Emoji ataupun Variable.`,
        },
        {
          target: '[data-tour-step="2.2"]',
          content: `Pesan dengan opsi Button, List ataupun Link/Call. 
          Untuk menggunakannya pastikan kamu sudah membuat Button ataupun Link/Call  di menu <b>Reply Buttons</b>.
          <br />
          <a target="_blank" href="https://s3-id-jkt-1.kilatstorage.id/aphrodite.enusoft.id/media/static/waajo_button_list_home.png"><img src="https://s3-id-jkt-1.kilatstorage.id/aphrodite.enusoft.id/media/static/waajo_button_list_home.png" style="width:100px;" /></a>
          `,
        },
        {
          target: '[data-tour-step="2.3"]',
          content: "Tampilan pesan yang akan dikirim",
        },
      ],
      whatsappBackground: process.env.VUE_APP_WHATSAPP_BACKGROUND,
      uploadMessageType: "image",
      messageTypeOptionsUpload: ["image", "document", "video"],
      broadcastParam: {
        message: {
          text: "",
          message_type: "text", //text,image,document
          file_url: "",
        },
        is_custom_url: false,
        interactive_message_status: false,
        interactive_message_type: "text_reply",
        footer_message_status: false,
        footer_message: "",
        list_button_text: "Options",
        buttons: [
          { id: "" },
          { id: "" },
          { id: "" },
          { id: "" },
          { id: "" },
          { id: "" },
          { id: "" },
          { id: "" },
          { id: "" },
          { id: "" },
        ],
        ab_testing_enabled: false,
        variants: [],
        pending_deleted_variant_codes: [],
        pending_deleted_variant_orders: [],
      },
      interactiveMessageTypeList: [
        // { id: "button_text", label: "Button" },
        // { id: "action_link", label: "Link/Call" },
        { id: "text_reply", label: "Text Reply" },
        // { id: "list_text", label: "List" }
      ],
      tabMessage: "setup", //setup or preview
      whatsappBackground: process.env.VUE_APP_WHATSAPP_BACKGROUND,
      buttonsLoading: false,
      defaultDetailButton: 10,
      linkParams: {
        columnFilters: {
          button_title: "",
          button_text: "",
          button_response: "",
        },
        page: 1,
        perPage: 500, // perPage
      },
      buttonsParams: {
        columnFilters: {
          button_title: "",
          button_text: "",
          button_response: "",
        },
        page: 1,
        perPage: 500, // perPage
      },

      selection: { start: 0, end: 0 },
      linkRows: [],
      buttonsRows: [],
      templateMessage: [
        "${first_name}",
        "${last_name}",
        "${phone_number}",
        "${email}",
        "${month_current}",
        "${month_current_name}",
        "${year_current}",
        "${today}",
        "${yesterday}",
        "${month_ago}",
        "${month_ago_name}",
        "${year_ago}",
      ],
      emojiAttr: {
        open: false,
        width: "0%",
        height: "0px",
      },
      objFilesMessageHandler: {
        file: null,
        // message_media: messaegMedia,
        media_type: "",
      },
      assetsUrl: [],
      caption: "",
      name: "file",
      thumbUpload: [],
      uploadAuto: true,
      uploadUrl:
        // process.env.VUE_APP_BASE_API + this.APICore() + "/omni/room/send-file",
        process.env.VUE_APP_BASE_API +
        this.APICore() +
        "/omni/only-upload-filev2",
      maximumUpload: 1,
      accept: "image/jfif,image/png,image/gif,image/jpeg,image/webp",
      extensions:
        "jfif, gif,jpg,jpeg,png,webp,zip,pdf,xls,xlsx, doc, docx, m4v, mp4",
      minSize: 1024,
      size: 1024 * 1024 * 10,
      files: [],
      isLoading: false,
      isSavingContent: false,
    };
  },
  watch: {
    broadcastStep: {
      handler: function (val, oldVal) {
        if (val == 2) {
          this.broadcastParam = structuredClone(this.broadcastParamSt);
          this.uploadMessageType = this.broadcastParam.message.message_type;
          this.activeVariantIndex = 0;
          if (
            this.broadcastParam.ab_testing_enabled &&
            this.broadcastParam.variants &&
            this.broadcastParam.variants.length
          ) {
            this.$nextTick(() => {
              this.loadVariantIntoEditor(0);
            });
          }
          // this.loadTextReply();
        }
      },
    },
    // uploadMessageType: {
    //   handler: function (val, oldVal) {
    //     if (val != "") {
    //       this.broadcastParam.message.message_type = val;
    //     } else {
    //       this.broadcastParam.message.message_type = "text";
    //     }

    //     this.formValidate();
    //   },
    //   deep: true
    // },
    // broadcastParam: {
    //   handler: function (val, oldVal) {
    //     // that.broadcastParam.message.message_type =
    //     //   that.broadcastParamSt.message.message_type;
    //     this.formValidate();
    //   },
    //   deep: true
    // },

    // activeIndex: {
    //   handler: function (val, oldVal) {
    //     // console.log("val", val, "oldVal", oldVal);
    //     if (val == true) {
    //       // console.log("active index")
    //       // this.selectedLicense = [];
    //       var that = this;
    //       setTimeout(function () {
    //         if (val == 1) {
    //           that.tourDetail();
    //           // console.log("broadcastParam", that.broadcastParam);
    //           // // that.broadcastParam = that.broadcastParamSt;
    //           // console.log("broadcastParam2", that.broadcastParam);

    //           that.broadcastParam.message.message_type =
    //             that.broadcastParamSt.message.message_type;
    //           that.uploadMessageType = that.broadcastParam.message.message_type;

    //           that.loadTextReply();
    //           // that.loadReplyButtons();
    //           // that.loadReplyLink();
    //         }
    //         // console.log("that.broadcastParamSt", that.broadcastParamSt);
    //         // that.formPar
    //         // that.asyncFindProduct();
    //         // console.log("")
    //       }, 100);
    //     }
    //   },
    //   deep: true
    // }
  },
  computed: {
    isAbTestingEnabled() {
      return this.broadcastParam.ab_testing_enabled === true;
    },
    activeVariants() {
      return (this.broadcastParam.variants || []).filter(
        (variant) => !variant.deleted
      );
    },
    activeVariant() {
      return this.activeVariants[this.activeVariantIndex] || null;
    },
    canAddVariant() {
      const pendingCount = (
        this.broadcastParam.pending_deleted_variant_codes || []
      ).length;

      return (
        this.activeVariants.length < this.maxVariants &&
        this.activeVariants.length + pendingCount < this.maxVariants &&
        this.nextVariantCode() !== null
      );
    },
    activeVariantKey() {
      if (!this.isAbTestingEnabled || !this.activeVariant) {
        return "single";
      }
      return (
        String(this.activeVariant.variant_code) +
        "-" +
        (this.activeVariant.id || "new")
      );
    },
    isVariantContentFilled() {
      const message = this.broadcastParam.message || {};
      const type = message.message_type || "text";

      if (type === "text") {
        return !!(message.text && message.text.trim() !== "");
      }
      return !!message.file_url;
    },
    isInteractiveValid() {
      if (!this.broadcastParam.interactive_message_status) {
        return false;
      }
      const buttons = (this.broadcastParam.buttons || []).filter(
        (button) => button && button.id
      );
      return (
        buttons.length > 0 &&
        (!this.broadcastParam.footer_message ||
          this.broadcastParam.footer_message.length <= 30)
      );
    },
    messageTypeLabel() {
      const type =
        (this.broadcastParam.message || {}).message_type || "text";
      const labels = {
        text: "Teks",
        image: "Gambar",
        video: "Video",
        document: "Dokumen",
      };
      return labels[type] || type;
    },
    computedAccept() {
      if (this.uploadMessageType === 'video') {
        return 'video/mp4,video/x-m4v';
      } else if (this.uploadMessageType === 'image') {
        return 'image/jfif,image/png,image/gif,image/jpeg,image/webp';
      }
      // Default untuk document / umum
      return 'image/*,video/mp4,video/x-m4v,application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/zip';
    },

    computedExtensions() {
      if (this.uploadMessageType === 'video') {
        return 'mp4,m4v';
      } else if (this.uploadMessageType === 'image') {
        return 'jfif,gif,jpg,jpeg,png,webp';
      }
      return 'jfif,gif,jpg,jpeg,png,webp,zip,pdf,xls,xlsx,doc,docx,m4v,mp4';
    },
    broadcastStep: {
      get() {
        return this.$store.state.omniwa.broadcastStep;
      },
      set(val) {
        this.$store.commit("omniwa/SET_broadcastStep", val);
      },
    },
    broadcastParamSt: {
      get() {
        return this.$store.state.omniwa.broadcastParamSt;
      },
      set(val) {
        this.$store.commit("omniwa/SET_broadcastParamSt", val);
      },
    },
    detailBroadcast() {
      return this.$store.state.omniwa.detailBroadcast;
    },
    headers() {
      return {
        // Authorization: this.getAuthBasic(),
        "X-Auth-Token": "Bearer " + this.getXAuthToken(),
        // "X-Auth-Agent": "Bearer " + this.getXAuthAgent()
      };
    },
  },
  filters: {
    capitalising: function (data) {
      var capitalized = [];
      data.split(" ").forEach((word) => {
        capitalized.push(
          word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        );
      });
      return capitalized.join(" ");
    },
  },
  methods: {
    variantStatusLabel(index) {
      const variant = this.activeVariants[index];
      if (!variant) return "";
      if (index === this.activeVariantIndex) return "Sedang diedit";
      return this.isVariantComplete(variant) ? "Siap" : "Belum diisi";
    },
    variantStatusIcon(index) {
      const variant = this.activeVariants[index];
      if (!variant) return "fa-circle-o";
      if (index === this.activeVariantIndex) return "fa-pencil";
      return this.isVariantComplete(variant)
        ? "fa-check-circle"
        : "fa-circle-o";
    },
    variantStatusClass(index) {
      const variant = this.activeVariants[index];
      if (!variant) return "is-incomplete";
      if (index === this.activeVariantIndex) return "is-editing";
      return this.isVariantComplete(variant) ? "is-ready" : "is-incomplete";
    },
    defaultButtons() {
      const buttons = [];
      for (let i = 0; i < 10; i++) {
        buttons.push({ id: "" });
      }
      return buttons;
    },
    onAbTestingToggle(event) {
      if (event.target.checked) {
        this.enableAbTesting();
      } else {
        this.disableAbTesting();
      }
    },
    createVariant(code, order, source) {
      const src = source || {};
      const srcMessage = src.message || {};
      return {
        id: src.id || "",
        variant_code: code,
        variant_order: order,
        message: {
          text: srcMessage.text || "",
          message_type: srcMessage.message_type || "text",
          file_url: srcMessage.file_url || "",
        },
        is_custom_url: !!src.is_custom_url,
        interactive_message_status: !!src.interactive_message_status,
        interactive_message_type: src.interactive_message_type || "text_reply",
        buttons:
          src.buttons && src.buttons.length
            ? structuredClone(src.buttons)
            : this.defaultButtons(),
        footer_message_status: !!src.footer_message_status,
        footer_message: src.footer_message || "",
        list_button_text: src.list_button_text || "Options",
        files: src.files || [],
        deleted: false,
      };
    },
    enableAbTesting() {
      if (!this.broadcastParam.variants) {
        this.$set(this.broadcastParam, "variants", []);
      }
      if (!this.broadcastParam.pending_deleted_variant_codes) {
        this.$set(this.broadcastParam, "pending_deleted_variant_codes", []);
      }
      if (!this.broadcastParam.pending_deleted_variant_orders) {
        this.$set(this.broadcastParam, "pending_deleted_variant_orders", []);
      }
      if (this.activeVariants.length === 0) {
        const variantA = this.createVariant("A", 1, this.broadcastParam);
        variantA.files = this.files;
        this.$set(this.broadcastParam, "variants", [variantA]);
      } else {
        const current = this.activeVariants[this.activeVariantIndex];
        if (current) current.files = this.files;
      }
      this.$set(this.broadcastParam, "ab_testing_enabled", true);
      this.activeVariantIndex = 0;
      this.loadVariantIntoEditor(0);
    },
    disableAbTesting() {
      this.syncActiveVariantContent();
      this.$set(this.broadcastParam, "ab_testing_enabled", false);
    },
    syncActiveVariantContent() {
      if (!this.activeVariants.length) return;
      const variant = this.activeVariants[this.activeVariantIndex];
      if (!variant) return;
      variant.message = this.broadcastParam.message;
      variant.is_custom_url = this.broadcastParam.is_custom_url;
      variant.interactive_message_status = this.broadcastParam.interactive_message_status;
      variant.interactive_message_type = this.broadcastParam.interactive_message_type;
      variant.buttons = this.broadcastParam.buttons;
      variant.footer_message_status = this.broadcastParam.footer_message_status;
      variant.footer_message = this.broadcastParam.footer_message;
      variant.list_button_text = this.broadcastParam.list_button_text;
      variant.files = this.files;
    },
    loadVariantIntoEditor(index) {
      const variant = this.activeVariants[index];
      if (!variant) return;
      this.broadcastParam.message = variant.message;
      this.broadcastParam.is_custom_url = variant.is_custom_url;
      this.broadcastParam.interactive_message_status = variant.interactive_message_status;
      this.broadcastParam.interactive_message_type = variant.interactive_message_type;
      this.broadcastParam.buttons = variant.buttons;
      this.broadcastParam.footer_message_status = variant.footer_message_status;
      this.broadcastParam.footer_message = variant.footer_message;
      this.broadcastParam.list_button_text = variant.list_button_text;
      this.uploadMessageType = variant.message.message_type;
      this.files = variant.files || [];
      this.activeVariantIndex = index;
    },
    switchVariant(index) {
      if (!this.isAbTestingEnabled) return;
      if (index < 0 || index >= this.activeVariants.length) return;
      this.syncActiveVariantContent();
      this.activeVariantIndex = index;
      this.loadVariantIntoEditor(index);
    },
    nextVariantCode() {
      const codes = ["A", "B", "C", "D", "E"];
      const used = this.activeVariants.map((variant) =>
        String(variant.variant_code || "").toUpperCase()
      );
      const pending = (this.broadcastParam.pending_deleted_variant_codes || []).map(
        (code) => String(code || "").toUpperCase()
      );
      for (let i = 0; i < codes.length; i++) {
        if (used.indexOf(codes[i]) === -1 && pending.indexOf(codes[i]) === -1) {
          return codes[i];
        }
      }
      return null;
    },
    nextVariantOrder() {
      const used = this.activeVariants.map((variant) =>
        Number(variant.variant_order)
      );
      const pending = (
        this.broadcastParam.pending_deleted_variant_orders || []
      ).map((order) => Number(order));
      let order = 1;
      while (used.indexOf(order) !== -1 || pending.indexOf(order) !== -1) {
        order++;
      }
      return order;
    },
    addVariant() {
      if (!this.isAbTestingEnabled) return;
      const pendingCount = (
        this.broadcastParam.pending_deleted_variant_codes || []
      ).length;
      if (
        this.activeVariants.length >= this.maxVariants ||
        this.activeVariants.length + pendingCount >= this.maxVariants
      ) {
        this.$fire({
          title: "Batas Tercapai",
          text: "Maksimal 5 varian per Broadcast. Simpan penghapusan varian terlebih dahulu bila perlu.",
          type: "warning",
        });
        return;
      }
      const code = this.nextVariantCode();
      if (!code) {
        this.$fire({
          title: "Tidak Bisa Menambah",
          text: "Simpan penghapusan varian terlebih dahulu sebelum menambah varian baru.",
          type: "warning",
        });
        return;
      }
      this.syncActiveVariantContent();
      const variant = this.createVariant(code, this.nextVariantOrder());
      this.broadcastParam.variants.push(variant);
      this.$nextTick(() => {
        this.loadVariantIntoEditor(this.activeVariants.length - 1);
      });
    },
    confirmRemoveVariant(index) {
      if (index <= 0) return;
      const variant = this.activeVariants[index];
      if (!variant) return;
      this.$fire({
        title: "Hapus Content " + variant.variant_code + "?",
        text: "Varian ini akan dihapus saat Broadcast disimpan. Varian lain tidak berubah.",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Ya, Hapus",
        cancelButtonText: "Batal",
      }).then((result) => {
        if (!result.value) return;
        this.syncActiveVariantContent();
        if (variant.id) {
          const codes = (this.broadcastParam.pending_deleted_variant_codes || []).slice();
          if (codes.indexOf(String(variant.variant_code)) === -1) {
            codes.push(String(variant.variant_code));
          }
          this.$set(this.broadcastParam, "pending_deleted_variant_codes", codes);

          const orders = (
            this.broadcastParam.pending_deleted_variant_orders || []
          ).slice();
          const variantOrder = Number(variant.variant_order);
          if (orders.indexOf(variantOrder) === -1) {
            orders.push(variantOrder);
          }
          this.$set(
            this.broadcastParam,
            "pending_deleted_variant_orders",
            orders
          );
        }
        this.broadcastParam.variants.splice(index, 1);

        if (index < this.activeVariantIndex) {
          this.activeVariantIndex -= 1;
        } else if (index === this.activeVariantIndex) {
          if (this.activeVariantIndex >= this.activeVariants.length) {
            this.activeVariantIndex = Math.max(
              0,
              this.activeVariants.length - 1
            );
          }
        }

        if (this.activeVariantIndex < 0) {
          this.activeVariantIndex = 0;
        }
        this.loadVariantIntoEditor(this.activeVariantIndex);
      });
    },
    isVariantComplete(variant) {
      if (!variant) return false;
      const message = variant.message || {};
      const messageType = message.message_type || "text";
      if (messageType === "text") {
        if (!message.text || message.text.trim() === "") return false;
      } else if (!message.file_url) {
        return false;
      }
      if (variant.interactive_message_status) {
        const buttons = (variant.buttons || []).filter(
          (button) => button && button.id
        );
        if (buttons.length === 0) return false;
        if (variant.footer_message && variant.footer_message.length > 30)
          return false;
      }
      if (
        variant.list_button_text &&
        variant.list_button_text.length > 20
      )
        return false;
      return true;
    },
    sanitizeVariantForStore(variant) {
      const message = variant.message || {};
      const isInteractive = !!variant.interactive_message_status;
      return {
        id: variant.id || "",
        variant_code: variant.variant_code,
        variant_order: Number(variant.variant_order) || 1,
        message: {
          text: message.text || "",
          message_type: message.message_type || "text",
          file_url: message.file_url || "",
        },
        is_custom_url: !!variant.is_custom_url,
        interactive_message_status: isInteractive,
        interactive_message_type: isInteractive
          ? variant.interactive_message_type || "text_reply"
          : "",
        buttons: (variant.buttons || []).map((button) => ({
          id: button && button.id ? button.id : "",
          button_text: button && button.button_text ? button.button_text : "",
        })),
        footer_message_status: !!variant.footer_message_status,
        footer_message: variant.footer_message || "",
        list_button_text: variant.list_button_text || "Options",
        deleted: false,
      };
    },
    clearActiveFile() {
      this.broadcastParam.message.file_url = "";
      this.files = [];
      this.thumbUpload = [];
    },
    applyStyle(symbol) {
      const textarea = this.$refs.messagebox;
      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;

      const text = this.broadcastParam.message.text;

      this.broadcastParam.message.text =
        text.slice(0, start) +
        symbol +
        text.slice(start, end) +
        symbol +
        text.slice(end);

      // this.showMenu = false;

      this.$nextTick(() => {
        textarea.focus();
        const cursorPos = start + symbol.length;
        textarea.setSelectionRange(cursorPos, cursorPos);
        this.$refs.messagebox.focus();
      });
    },
    async loadTextReply() {
      this.buttonsLoading = await true;
      this.textReplyParams.page = 0;
      await this.$store
        .dispatch("automation/listTextReply", this.textReplyParams) // sesuai kan dengan method di API
        .then((response) => {
          const { data } = response;
          this.textReplyRows = data.data;
          this.buttonsLoading = false;
        })
        .catch((error) => {
          this.buttonsLoading = false;
          console.log(error);
        });
    },
    tourShow() {
      this.$tours["tourGuide2"].start();
    },
    tourComplete() {
      let params = {};
      params = {
        tour_id: this.tourId,
      };
      this.$store.dispatch("tour/tourComplete", params);
    },
    tourDetail() {
      let params = {};
      params = {
        tour_id: this.tourId,
      };
      this.$store.dispatch("tour/tourDetail", params).then((response) => {
        var { data } = response;
        if (data.id == "") {
          this.tourShow();
        }
      });
    },
    addTemplateToMesage(template) {
      this.broadcastParam.message.text += template;
    },
    updateMessageTypeCurrent(msgType) {
      this.broadcastParam.message.message_type = msgType;
      this.uploadMessageType = msgType;
    },
    settabMessage(value) {
      this.tabMessage = value;
    },
    resetDetailButton() {
      this.broadcastParam.buttons = [
        { id: "" },
        { id: "" },
        { id: "" },
        { id: "" },
        { id: "" },
        { id: "" },
        { id: "" },
        { id: "" },
        { id: "" },
        { id: "" },
      ];
      this.syncActiveVariantContent();
    },
    async loadReplyLink() {
      this.buttonsLoading = await true;
      this.linkParams.page = 0;
      await this.$store
        .dispatch("automation/listReplyLink", this.linkParams) // sesuai kan dengan method di API
        .then((response) => {
          const { data } = response;
          this.linkRows = data.data;
          this.buttonsLoading = false;
        })
        .catch((error) => {
          this.buttonsLoading = false;
          console.log(error);
        });
    },
    async loadReplyButtons() {
      this.buttonsLoading = await true;
      this.buttonsParams.page = 0;
      await this.$store
        .dispatch("automation/listReplyButtons", this.buttonsParams) // sesuai kan dengan method di API
        .then((response) => {
          const { data } = response;
          this.buttonsRows = data.data;
          this.buttonsLoading = false;
        })
        .catch((error) => {
          this.buttonsLoading = false;
          console.log(error);
        });
    },
    emojiToggle(isClosed) {
      // console.log("clicked toggle");
      if (typeof isClosed == "undefined") {
        if (this.emojiAttr.open == true) {
          this.emojiAttr.open = false;
        } else {
          this.emojiAttr.open = true;
        }
      } else {
        this.emojiAttr.open = isClosed;
      }

      if (this.emojiAttr.open == true) {
        this.emojiAttr.width = "96%";
        this.emojiAttr.height = "250px";
      } else {
        this.emojiAttr.width = "0%";
        this.emojiAttr.height = "0px";
      }

      // console.log("this.emojiAttr.open:: ", this.emojiAttr.open);
    },
    selectedEmoji(args) {
      const textarea = this.$refs.messagebox; // pastikan textarea punya ref="messagebox"
      if (!textarea) return;
      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;

      this.broadcastParam.message.text =
        this.broadcastParam.message.text.substring(0, start) +
        args.emoji +
        this.broadcastParam.message.text.substring(end);
      this.$nextTick(() => {
        textarea.focus();
        const cursorPos = start + args.emoji.length;
        textarea.setSelectionRange(cursorPos, cursorPos);
      });
      this.emojiToggle(false);
      // console.log(args); /* return {...}*/
    },
    inputFileHandler(e) {
      if (e.keyCode === 13 && !e.shiftKey) {
        e.preventDefault();
        this.$refs.uploadbc.active = true;
      }
    },
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // 1. Filter file sistem & tersembunyi
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent();
        }
        // 2. Filter file eksekusi web
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent();
        }

        // 3. Validasi khusus jika tipe pesan diset ke "video"
        if (this.uploadMessageType === "video") {
          const isVideo = /\.(mp4|m4v)$/i.test(newFile.name);
          if (!isVideo) {
            alert("Untuk tipe pesan video, hanya file .mp4 dan .m4v yang diperbolehkan.");
            return prevent();
          }
        }

        // 4. Validasi khusus jika tipe pesan diset ke "image"
        if (this.uploadMessageType === "image") {
          const isImage = /\.(jfif|gif|jpg|jpeg|png|webp)$/i.test(newFile.name);
          if (!isImage) {
            alert("Untuk tipe pesan gambar, hanya file gambar (jpg, png, gif, webp) yang diperbolehkan.");
            return prevent();
          }
        }

        // 5. Otomatis kompresi jika file berupa Gambar
        if (
          newFile.file &&
          newFile.error === "" &&
          newFile.type.startsWith("image/") &&
          this.autoCompress > 0 &&
          this.autoCompress < newFile.size
        ) {
          newFile.error = "compressing";
          const imageCompressor = new ImageCompressor(null, {
            convertSize: 1024 * 1024,
            maxWidth: 512,
            maxHeight: 512,
          });

          imageCompressor
            .compress(newFile.file)
            .then((file) => {
              this.$refs.uploadbc.update(newFile, {
                error: "",
                file,
                size: file.size,
                type: file.type,
              });
            })
            .catch((err) => {
              this.$refs.uploadbc.update(newFile, {
                error: err.message || "compress error",
              });
            });
        }
      }

      // 6. Tangkap Hasil Respons Upload Backend & Set file_url (Aman dari sintaks lama Babel)
      if (newFile && newFile.success && (!oldFile || !oldFile.success)) {
        const res = newFile.response;
        const responseUrl =
          (res && res.data && res.data.file_url) ||
          (res && res.file_url) ||
          (res && res.url) ||
          "";

        if (responseUrl) {
          this.broadcastParam.message.file_url = responseUrl;
        }
      }

      // 7. Generate Blob URL & Thumbnail Preview
      if (
        newFile &&
        newFile.error === "" &&
        newFile.file &&
        (!oldFile || newFile.file !== oldFile.file)
      ) {
        newFile.blob = "";
        let URL = window.URL || window.webkitURL;
        if (URL) {
          newFile.blob = URL.createObjectURL(newFile.file);
        }
        newFile.thumb = "";
        if (newFile.blob && newFile.type.startsWith("image/")) {
          newFile.thumb = newFile.blob;
        }
      }

      // 8. Ambil Dimensi Gambar
      if (
        newFile &&
        newFile.error === "" &&
        newFile.type.startsWith("image/") &&
        newFile.blob &&
        (!oldFile || newFile.blob !== oldFile.blob)
      ) {
        let img = new Image();

        img.onload = () => {
          this.$refs.uploadbc.update(newFile, {
            height: img.height,
            width: img.width,
          });
        };

        img.onerror = (e) => {
          console.error("Error parsing image dimension:", e);
        };

        img.src = newFile.blob;
      }
    },
    inputFilterx(newFile, oldFile, prevent) {
      console.log("newFile, oldFile", newFile, oldFile);
      if (newFile && !oldFile) {
        // Before adding a file
        // 添加文件前
        // Filter system files or hide files
        // 过滤系统文件 和隐藏文件
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent();
        }
        // Filter php html js file
        // 过滤 php html js 文件
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent();
        }

        // var liContainer = document.getElementById("drag_files");
        // var isShowModal = liContainer.classList.contains("show");
        // console.log("isShowModal",isShowModal)
        // if (isShowModal == false) {
        //   // document.getElementById("btnDragFiles").click(); // Click on the checkbox
        // }
        // Automatic compression
        // 自动压缩
        if (
          newFile.file &&
          newFile.error === "" &&
          newFile.type.substr(0, 6) === "image/" &&
          this.autoCompress > 0 &&
          this.autoCompress < newFile.size
        ) {
          // console.log("compressing", newFile, oldFile);

          newFile.error = "compressing";
          const imageCompressor = new ImageCompressor(null, {
            convertSize: 1024 * 1024,
            maxWidth: 512,
            maxHeight: 512,
          });
          imageCompressor
            .compress(newFile.file)
            .then((file) => {
              this.$refs.uploadbc.update(newFile, {
                error: "",
                file,
                size: file.size,
                type: file.type,
              });
            })
            .catch((err) => {
              this.$refs.uploadbc.update(newFile, {
                error: err.message || "compress",
              });
            });
        }
      }
      console.log("humb newFile, oldFile: ", newFile, oldFile);
      if (
        newFile &&
        newFile.error === "" &&
        newFile.file &&
        (!oldFile || newFile.file !== oldFile.file)
      ) {
        // Create a blob field
        // 创建 blob 字段
        newFile.blob = "";
        let URL = window.URL || window.webkitURL;
        if (URL) {
          newFile.blob = URL.createObjectURL(newFile.file);
        }
        // Thumbnails
        // 缩略图
        newFile.thumb = "";
        if (newFile.blob && newFile.type.substr(0, 6) === "image/") {
          newFile.thumb = newFile.blob;
        }
      }
      // image size
      // image 尺寸
      if (
        newFile &&
        newFile.error === "" &&
        newFile.type.substr(0, 6) === "image/" &&
        newFile.blob &&
        (!oldFile || newFile.blob !== oldFile.blob)
      ) {
        newFile.error = "image parsing";
        let img = new Image();
        img.onload = () => {
          this.$refs.uploadbc.update(newFile, {
            error: "",
            height: img.height,
            width: img.width,
          });
        };
        img.οnerrοr = (e) => {
          console.log("errorr", e);
          this.$refs.uploadbc.update(newFile, { error: "parsing image size" });
        };
        img.src = newFile.blob;
      }
    },
    inputFile(newFile, oldFile) {
      // console.log("inputFile:oldddd", oldFile);
      // console.log("inputFile:newf", newFile);
      if (newFile && oldFile) {
        // console.log("oldddd", oldFile);
        // console.log("newf", newFile);
        // update
        if (newFile.active && !oldFile.active) {
          //buildData
          let dataArr = {
            message_type: this.uploadMessageType,
          };
          // this.$store.dispatch("omniwa/actFilesMessageHandler", dataArr);
          this.objFilesMessageHandler = dataArr;
          this.$refs.uploadbc.update(newFile, { data: dataArr });

          // beforeSend
          // min size
          if (
            newFile.size >= 0 &&
            this.minSize > 0 &&
            newFile.size < this.minSize
          ) {
            this.$refs.uploadbc.update(newFile, { error: "size" });
          }
        }
        if (newFile.progress !== oldFile.progress) {
          // progress
          // console.log("progress", newFile.progress);
        }
        if (newFile.error && !oldFile.error) {
          // console.log("err", newFile.error.response);
          // console.log("newFile", newFile);
          this.$refs.uploadbc.update(newFile, { progress: 0 });

          // error
          this.$fire({
            title: "Error",
            text: newFile.response.msg,
            type: "error",
            timer: 1000,
          }).then((r) => { });
        }
        if (newFile.success && !oldFile.success) {
          this.broadcastParam.message.file_url = newFile.response.data.url;
          // this.caption = "";
          this.thumbUpload.push(newFile.thumb);
          // this.$refs.uploadbc.update(newFile, { progress: 0 });
          // this.$refs.uploadbc.clear();
          // this.$refs.upload.remove(newFile);
          // this.$refs.uploadbc.active = false;

          // success
          // console.log("this.thumbUpload", this.thumbUpload);
          // console.log("success", newFile.success, newFile);
        }
      }
      if (!newFile && oldFile) {
        this.broadcastParam.message.file_url = "";
        // remove
        if (oldFile.success && oldFile.response.id) {
        }
      }
      // Automatically activate upload
      if (
        Boolean(newFile) !== Boolean(oldFile) ||
        oldFile.error !== newFile.error
      ) {
        if (this.uploadAuto && !this.$refs.uploadbc.active) {
          this.$refs.uploadbc.active = true;
        }
      }
    },
    async handleSaveClick() {
      if (this.isSavingContent) return;
      this.isSavingContent = true;
      try {
        await this.saveForm(0);
      } finally {
        this.$nextTick(() => {
          this.isSavingContent = false;
        });
      }
    },
    saveForm() {
      // Pastikan perubahan editor aktif tersimpan ke objek varian aktif.
      this.syncActiveVariantContent();

      if (this.isAbTestingEnabled) {
        if (this.activeVariants.length === 0) {
          this.$fire({
            title: "Error",
            text: "Minimal 1 varian diperlukan untuk Variasi Pesan.",
            type: "error",
            timer: 2000,
          });
          return;
        }

        const invalidIndex = this.activeVariants.findIndex(
          (variant) => !this.isVariantComplete(variant)
        );

        if (invalidIndex !== -1) {
          const invalidVariant = this.activeVariants[invalidIndex];
          this.loadVariantIntoEditor(invalidIndex);
          this.$fire({
            title: "Varian Belum Lengkap",
            text:
              "Content " +
              invalidVariant.variant_code +
              " belum lengkap. Lengkapi pesan/media dan pengaturan interaktifnya.",
            type: "error",
            timer: 2500,
          });
          return;
        }
      } else {
        // validasi Broadcast biasa (perilaku lama)
        if (
          this.broadcastParam.message.message_type != "text" &&
          this.broadcastParam.message.file_url == ""
        ) {
          //error no media
          this.$fire({
            title: "Error",
            text:
              "File is required for " +
              this.broadcastParam.message.message_type +
              " message!",
            type: "error",
            timer: 2000,
          }).then((r) => { });
          return;
        }

        if (
          this.broadcastParam.message.message_type == "text" &&
          this.broadcastParam.message.text.trim() == ""
        ) {
          //error no text for type text
          this.$fire({
            title: "Error",
            text:
              "Text is required for " +
              this.broadcastParam.message.message_type +
              " message!",
            type: "error",
            timer: 2000,
          }).then((r) => { });
          return;
        }
      }

      if (this.isAbTestingEnabled) {
        // Variasi utama = variant_order terkecil.
        const primary = this.activeVariants
          .slice()
          .sort((a, b) => Number(a.variant_order) - Number(b.variant_order))[0];

        if (primary) {
          this.broadcastParamSt.message = {
            text: primary.message.text || "",
            message_type: primary.message.message_type || "text",
            file_url: primary.message.file_url || "",
          };
          this.broadcastParamSt.is_custom_url = !!primary.is_custom_url;
          this.broadcastParamSt.interactive_message_status =
            !!primary.interactive_message_status;
          this.broadcastParamSt.interactive_message_type =
            primary.interactive_message_type || "";
          this.broadcastParamSt.buttons = (primary.buttons || []).map(
            (button) => ({
              id: button && button.id ? button.id : "",
              button_text:
                button && button.button_text ? button.button_text : "",
            })
          );
          this.broadcastParamSt.footer_message_status =
            !!primary.footer_message_status;
          this.broadcastParamSt.footer_message =
            primary.footer_message || "";
          this.broadcastParamSt.list_button_text =
            primary.list_button_text || "Options";
        }

        this.$set(this.broadcastParamSt, "ab_testing_enabled", true);
        this.$set(
          this.broadcastParamSt,
          "variants",
          this.activeVariants.map((variant) =>
            this.sanitizeVariantForStore(variant)
          )
        );
        this.$set(
          this.broadcastParamSt,
          "pending_deleted_variant_codes",
          (this.broadcastParam.pending_deleted_variant_codes || []).slice()
        );
        this.$set(
          this.broadcastParamSt,
          "pending_deleted_variant_orders",
          (this.broadcastParam.pending_deleted_variant_orders || []).slice()
        );
      } else {
        this.broadcastParamSt.is_custom_url = this.broadcastParam.is_custom_url;
        this.broadcastParamSt.message.text = this.broadcastParam.message.text;
        this.broadcastParamSt.message.file_url =
          this.broadcastParam.message.file_url;
        this.broadcastParamSt.message.message_type =
          this.broadcastParam.message.message_type;
        this.broadcastParamSt.interactive_message_status =
          this.broadcastParam.interactive_message_status;
        this.broadcastParamSt.interactive_message_type =
          this.broadcastParam.interactive_message_type;
        this.broadcastParamSt.buttons = this.broadcastParam.buttons;
        this.broadcastParamSt.footer_message_status =
          this.broadcastParam.footer_message_status;
        this.broadcastParamSt.footer_message =
          this.broadcastParam.footer_message;

        // Simpan data varian agar tidak hilang saat mode Variasi Pesan dimatikan.
        this.$set(this.broadcastParamSt, "ab_testing_enabled", false);
        this.$set(
          this.broadcastParamSt,
          "variants",
          this.activeVariants.map((variant) =>
            this.sanitizeVariantForStore(variant)
          )
        );
        this.$set(
          this.broadcastParamSt,
          "pending_deleted_variant_codes",
          (this.broadcastParam.pending_deleted_variant_codes || []).slice()
        );
        this.$set(
          this.broadcastParamSt,
          "pending_deleted_variant_orders",
          (this.broadcastParam.pending_deleted_variant_orders || []).slice()
        );
      }

      this.broadcastStep = "";
    },
    cancelForm() {
      this.$fire({
        title: "Are you sure?",
        text: "Message will not be saved.",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`,
      }).then((result) => {
        if (result.value) {
          this.goBack();
        }
      });
    },
    goBack() {
      console.log("back");
      this.$store.commit("omniwa/SET_broadcastStep", "");
    },
    formatSizes(bytes) {
      return formatSizes(bytes);
    },
    getExt(filename) {
      return filename.split(".").pop();
    },
    getAuthBasic() {
      return getAuthBasic();
    },

    getXAuthToken() {
      return getXAuthToken();
    },
    getXAuthAgent() {
      return getXAuthAgent();
    },
    messageFilter(message) {
      return message.replace(/\r?\n/g, "<br />");
    },
    APICore() {
      return APICore();
    },
    APICoreV2() {
      return APICoreV2();
    },
    formValidate() {
      let newParam = this.broadcastParamSt;
      newParam.is_custom_url = this.broadcastParam.is_custom_url;
      newParam.message.text = this.broadcastParam.message.text;
      newParam.message.file_url = this.broadcastParam.message.file_url;
      newParam.message.message_type = this.broadcastParam.message.message_type;
      newParam.interactive_message_status =
        this.broadcastParam.interactive_message_status;
      newParam.interactive_message_type =
        this.broadcastParam.interactive_message_type;
      newParam.buttons = this.broadcastParam.buttons;
      newParam.footer_message_status =
        this.broadcastParam.footer_message_status;
      newParam.footer_message = this.broadcastParam.footer_message;
      this.uploadMessageType = this.broadcastParam.message.message_type;
      this.$store.dispatch("omniwa/actBroadcastParamSt", newParam);
    },
  },
  async created() { },
  beforeDestroy() { },
  mounted() {
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function (e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "form2-add",
};
</script>

<style scoped>
.ab-testing-toggle {
  display: flex;
  align-items: flex-start;
  border: 1px solid #f6d7b8;
  border-radius: 10px;
  padding: 14px 16px;
  background: linear-gradient(90deg, #fffaf5 0%, #ffffff 100%);
}

.ab-testing-icon {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: #fff1e5;
  color: #fe9b44;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  margin-right: 12px;
  flex: 0 0 38px;
}

.ab-testing-content {
  flex: 1 1 auto;
  min-width: 0;
}

.ab-switch {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;
  flex: 0 0 44px;
  cursor: pointer;
}

.ab-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.ab-switch-slider {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ced4da;
  border-radius: 999px;
  transition: background-color 0.2s ease;
}

.ab-switch-slider::before {
  content: "";
  position: absolute;
  height: 18px;
  width: 18px;
  left: 3px;
  top: 3px;
  background-color: #fff;
  border-radius: 50%;
  transition: transform 0.2s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.ab-switch input:checked + .ab-switch-slider {
  background-color: #70c95a;
}

.ab-switch input:checked + .ab-switch-slider::before {
  transform: translateX(20px);
}

.ab-variant-grid {
  margin-left: -6px;
  margin-right: -6px;
}

.ab-variant-grid > [class*="col-"] {
  display: flex;
  padding-left: 6px;
  padding-right: 6px;
}

.ab-variant-card {
  position: relative;
  width: 100%;
  border: 1px solid #e9ecef;
  border-radius: 10px;
  background: #fff;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.ab-variant-card:hover {
  border-color: #f6c79f;
}

.ab-variant-card.active {
  border-color: #fe9b44;
  box-shadow: 0 0 0 2px rgba(254, 155, 68, 0.15);
}

.ab-variant-main {
  display: flex;
  align-items: center;
  width: 100%;
  border: 0;
  background: transparent;
  padding: 12px 38px 12px 12px;
  text-align: left;
  cursor: pointer;
}

.ab-variant-code {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 13px;
  margin-right: 10px;
  flex: 0 0 32px;
}

.ab-variant-code.is-ready {
  background: #e7f6e4;
  color: #3f8f34;
}

.ab-variant-code.is-editing {
  background: #fff1e5;
  color: #d97a18;
}

.ab-variant-code.is-incomplete {
  background: #f1f3f5;
  color: #868e96;
}

.ab-variant-info {
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.ab-variant-title {
  font-weight: 600;
  color: #343a40;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ab-variant-status {
  font-size: 12px;
  line-height: 1.4;
  margin-top: 2px;
}

.ab-variant-status.is-ready {
  color: #3f8f34;
}

.ab-variant-status.is-editing {
  color: #d97a18;
}

.ab-variant-status.is-incomplete {
  color: #868e96;
}

.ab-variant-delete {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 26px;
  height: 26px;
  border: 0;
  border-radius: 50%;
  background: #fff;
  color: #dc3545;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  opacity: 0.7;
}

.ab-variant-delete:hover {
  opacity: 1;
  background: #fdecee;
}

.ab-variant-add {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 70px;
  border: 1px dashed #f0b57c;
  border-radius: 10px;
  background: #fffdfb;
  color: #d97a18;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.ab-variant-add:hover {
  background: #fff5eb;
}

.ab-variant-add.disabled {
  border-color: #e9ecef;
  background: #f8f9fa;
  color: #adb5bd;
  cursor: not-allowed;
}

.ab-variant-add .fa {
  font-size: 16px;
  margin-bottom: 4px;
}

.ab-variant-add-title {
  font-weight: 600;
  font-size: 13px;
}

.ab-variant-add-sub {
  font-size: 11px;
  margin-top: 2px;
}

.ab-editor-card,
.ab-preview-card {
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 12px;
}

.ab-card-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
  padding: 16px 18px;
  border-bottom: 1px solid #f1f3f5;
}

.ab-card-body {
  padding: 16px 18px;
}

.ab-status-pill {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
}

.ab-status-pill .fa {
  margin-right: 5px;
}

.ab-status-pill.is-ready {
  background: #e7f6e4;
  color: #3f8f34;
}

.ab-status-pill.is-editing {
  background: #fff1e5;
  color: #d97a18;
}

.ab-status-pill.is-incomplete {
  background: #f1f3f5;
  color: #868e96;
}

.ab-section {
  margin-bottom: 18px;
}

.ab-section:last-child {
  margin-bottom: 0;
}

.ab-section-title {
  display: block;
  font-weight: 600;
  color: #343a40;
  margin-bottom: 8px;
}

.ab-preview-body {
  padding: 16px;
}

.ab-preview-body #preview {
  border-radius: 10px;
  overflow: hidden;
}

.ab-checklist {
  border-top: 1px solid #f1f3f5;
  padding: 14px 18px 16px;
}

.ab-checklist-title {
  font-weight: 600;
  font-size: 12px;
  color: #868e96;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 8px;
}

.ab-check-item {
  display: flex;
  align-items: flex-start;
  font-size: 13px;
  margin-bottom: 6px;
}

.ab-check-item:last-child {
  margin-bottom: 0;
}

.ab-check-item .fa {
  margin-right: 8px;
  margin-top: 2px;
  flex: 0 0 14px;
}

.ab-check-item.is-ok .fa {
  color: #3f8f34;
}

.ab-check-item.is-pending .fa {
  color: #adb5bd;
}

.ab-check-item.is-optional {
  color: #868e96;
}

.ab-nav-actions .btn {
  min-width: 120px;
}

.bc-action-buttons {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 16px;
}

.bc-action-btn {
  min-width: 150px;
  padding: 9px 20px;
  font-size: 14px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.bc-action-btn .fa {
  margin-right: 6px;
}

.bc-action-btn + .bc-action-btn {
  margin-left: 8px;
}

.bc-action-btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

@media (max-width: 575.98px) {
  .bc-action-buttons {
    flex-direction: column;
    align-items: stretch;
  }

  .bc-action-btn {
    width: 100%;
    min-width: 0;
  }

  .bc-action-btn + .bc-action-btn {
    margin-left: 0;
    margin-top: 8px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/broadcast/componentsV2/Forms/form2.vue